import { RetryStrategy } from './types';

const DEFAULT_DELAYS_IN_MS = [1000, 3000, 8000, 16000, 32000];
const DEFAULT_JITTER = 0.2;

export class ConfigurableBackoffStrategy implements RetryStrategy {
    private attemptNumber = 0;
    private readonly delaysInMs: number[];
    private readonly jitter: number;

    constructor(delaysInMs: number[] = DEFAULT_DELAYS_IN_MS, jitter = DEFAULT_JITTER) {
        if (delaysInMs.length === 0) {
            throw new Error('delays must be a non-empty array');
        }

        if (delaysInMs.some((delay) => delay < 0 || !Number.isFinite(delay))) {
            throw new Error('all delays must be non-negative finite numbers');
        }

        if (jitter < 0 || jitter > 1) {
            throw new Error('jitter must be a number between 0 and 1');
        }

        this.delaysInMs = delaysInMs;
        this.jitter = jitter;
    }

    nextAttempt(): Promise<void> {
        if (this.attemptNumber === 0) {
            this.attemptNumber++;
            return Promise.resolve();
        }

        const delayIndex = Math.min(this.attemptNumber - 1, this.delaysInMs.length - 1);
        const baseDelayInMs = this.delaysInMs[delayIndex];
        const delayWithJitterInMs = this.jitterUp(baseDelayInMs, this.jitter);

        this.attemptNumber++;

        return new Promise<void>((resolve) => setTimeout(resolve, delayWithJitterInMs));
    }

    private jitterUp(duration: number, jitter: number): number {
        const multiplier = jitter * (Math.random() * 2 - 1);
        return duration * (1 + multiplier);
    }
}
